import { orderXClient } from '@/service/client'
import {
  type BatchOrderPreviewRequest,
  type BatchOrderPreviewResponse,
  ServerMessage,
} from '@/types/generated/public_api'

export async function getBatchOrderPreview(
  req: BatchOrderPreviewRequest
): Promise<BatchOrderPreviewResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { batchOrderPreview: req })
  if (data.error) {
    return Promise.reject(data.error)
  }
  if (!data.batchOrderPreviewResponse) {
    return Promise.reject(new Error('No batch order preview returned'))
  }
  return data.batchOrderPreviewResponse
}
